module.exports = __webpack_public_path__ + "static/media/zadania-powtorkowe-do-egzaminu-osmoklasisty-matematyka-8-2.531181a4.jpg";